import React from 'react';
import axios from "axios";
import {backendEndpoints} from "../../libs/backendEndpoints";
import Button from "react-bootstrap/Button";
import {useConfirm} from "../contexts/ConfirmationModalContext";
import {adminRoutes} from "../../utils/routes";
import {Trash3} from "react-bootstrap-icons";
import {SubscriptionRule} from "fearless-common";

export default function SubscriptionRuleDeleteButton({ rule }: { rule: SubscriptionRule }) {
    const { open } = useConfirm();
    return (
        <Button
            variant="outline-danger"
            size="sm"
            onClick={() => {
                open(
                    `Are you sure you want to delete this?`,
                    () => axios.delete(backendEndpoints.deleteSubscriptionRule(rule.id))
                        .then(() => {
                            window.location.href = adminRoutes.subscriptionRules;
                        }),
                    true,
                )
            }}
        >
            <Trash3 />
            &nbsp;Archive rule
        </Button>
    );
}
